export default "__VITE_ASSET__Do6u9if3__"